import { endOfDay, isSameDay, startOfDay } from 'date-fns'

export const isOnCorrectDay = (content, date) => {
  const startDate = startOfDay(new Date(content.scheduled_at))
  const takedownDate = endOfDay(new Date(content.takedown_scheduled_at))

  if (content.takedown_scheduled_at) {
    return startDate <= date && takedownDate >= date
  }

  return isSameDay(startDate, date)
}

export default { isOnCorrectDay }
